import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { TagForm } from '@/components/forms/TagForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function TagsCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/content-management/tags')
  }

  const handleCancel = () => {
    navigate('/content-management/tags')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Tag</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Create a new tag and organize your content.
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <TagForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


